export default __webpack_public_path__ + "static/media/AllerLight.c146227f.ttf";